import axios from "axios";

// Use REACT_APP_LOGINURL which always gives base URL with /api/
const BASE_URL = process.env.REACT_APP_LOGINURL || "http://localhost:3005/api/";

// Construct complaints API URL
const API_URL = BASE_URL.replace(/\/$/, '') + '/complaints';

const headers = {
  'Content-Type': 'application/json',
  'token': localStorage.getItem("session-id")
}

// Get all complaint categories (for CRUD management)
const getAll = (postData = {}) => {
  var payload = {
    functionName: "GetComplaintCategoriesList",
    postData: postData
  }
  return axios.post(API_URL, payload, { headers });
};

// Add complaint category
const addCategory = (postData) => {
  var payload = {
    functionName: "AddComplaintCategory",
    postData: postData
  }
  return axios.post(API_URL, payload, { headers });
};

// Update complaint category
const updateCategory = (postData) => {
  var payload = {
    functionName: "UpdateComplaintCategory",
    postData: postData
  }
  return axios.post(API_URL, payload, { headers });
};

// Delete complaint category
const deleteCategory = (id) => {
  var payload = {
    functionName: "DeleteComplaintCategory",
    postData: {
      _id: id
    }
  }
  return axios.post(API_URL, payload, { headers });
};

// Toggle complaint category status (Active/Inactive)
const toggleStatus = (id) => {
  var payload = {
    functionName: "ToggleComplaintCategoryStatus",
    postData: {
      _id: id
    }
  }
  return axios.post(API_URL, payload, { headers });
};

const ComplaintCategoriesService = {
  getAll,
  addCategory,
  updateCategory,
  deleteCategory,
  toggleStatus
}

export default ComplaintCategoriesService;


